export const slugify = (value) => {
	if (!value) return '';
	return value
		.toString()
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
};

const IRREGULAR_PLURALS = {
	person: 'people',
	child: 'children',
	man: 'men',
	woman: 'women',
	foot: 'feet',
	tooth: 'teeth',
	goose: 'geese',
	mouse: 'mice',
	ox: 'oxen',
	die: 'dice',
	leaf: 'leaves',
	life: 'lives',
	knife: 'knives',
	wife: 'wives',
	half: 'halves',
	shelf: 'shelves',
	wolf: 'wolves',
	loaf: 'loaves',
	thief: 'thieves',
	calf: 'calves',
	potato: 'potatoes',
	tomato: 'tomatoes',
	hero: 'heroes',
	echo: 'echoes',
	veto: 'vetoes',
	analysis: 'analyses',
	basis: 'bases',
	crisis: 'crises',
	diagnosis: 'diagnoses',
	criterion: 'criteria',
	phenomenon: 'phenomena',
	cactus: 'cacti',
	focus: 'foci',
	fungus: 'fungi',
	nucleus: 'nuclei',
	syllabus: 'syllabi',
	index: 'indices',
	appendix: 'appendices',
	matrix: 'matrices',
	vertex: 'vertices',
	quiz: 'quizzes',
};

const UNCOUNTABLE = new Set([
	'sheep', 'fish', 'deer', 'moose', 'series', 'species', 'aircraft',
	'money', 'information', 'equipment', 'news', 'staff', 'data',
]);

const matchCase = (result, source) => {
	if (!source) return result;
	if (source === source.toUpperCase() && source.length > 1) return result.toUpperCase();
	if (source[0] === source[0].toUpperCase()) return result.charAt(0).toUpperCase() + result.slice(1);
	return result;
};

const pluralizeWord = (word) => {
	const lower = word.toLowerCase();
	if (UNCOUNTABLE.has(lower)) return word;
	const isAllCaps = word.length > 1 && word === word.toUpperCase();
	const suffix = (s) => (isAllCaps ? s.toUpperCase() : s);
	if (IRREGULAR_PLURALS[lower]) return matchCase(IRREGULAR_PLURALS[lower], word);
	if (/[^aeiou]y$/i.test(word)) return word.slice(0, -1) + suffix('ies');
	if (/(ss|us|x|z|ch|sh)$/i.test(word)) return word + suffix('es');
	// A word already ending in a plain "s" is usually already plural ("Notes") — leave it.
	if (/s$/i.test(word)) return word;
	return word + suffix('s');
};

// Pluralize the final word of a phrase: "Blood pressure reading" -> "Blood pressure readings".
export const pluralize = (phrase) => {
	const value = (phrase ?? '').toString();
	if (!value.trim()) return '';
	return value.replace(/(\S+)(\s*)$/, (match, word, trail) => pluralizeWord(word) + trail);
};

/**
 * Text folded for matching: lower case, compatibility forms (NFKD — "m³" reads
 * "m3") and diacritics stripped, so "cafe" finds "Café". The one folding every
 * searchable Select uses (components/Input.js optionSearchFilter re-exports
 * it) and the builders' value check (utils/idValueValidation.js) compares with.
 */
export const foldSearchText = text => String(text ?? '')
	.normalize('NFKD')
	.replace(/[\u0300-\u036f]/g, '')
	.toLowerCase();
